/**
 * Data export job status values (insert-only jobs; not status_tracking).
 */
export enum DataExportJobStatusEnum {
  COMPLETED = 'completed',
  FAILED = 'failed',
}
